jQuery(function ($) {

  function getByPath(obj, path) {
    if (!path) return obj;
    return path.split('.').reduce((o, k) => (o || {})[k], obj);
  }

  function exportCSV(chart) {
    let csv = 'Label,' + chart.data.datasets.map(d => d.label).join(',') + '\n';
    chart.data.labels.forEach((label, i) => {
      csv += label + ',' + chart.data.datasets.map(d => d.data[i]).join(',') + '\n';
    });
    const blob = new Blob([csv], { type: 'text/csv' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'chart.csv';
    a.click();
  }

  $('.chart canvas').each(function () {
    const $el = $(this);
    const ctx = this.getContext('2d');

    const chart = new Chart(ctx, {
      type: $el.data('type'),
      data: {
        labels: $el.data('labels') || [],
        datasets: $el.data('datasets') || []
      },
      options: {
        responsive: true,
        animation: $el.data('animate') == 1 ? {
          duration: $el.data('duration'),
          easing: $el.data('easing')
        } : false,
        plugins: {
          legend: { display: !$el.data('sparkline') }
        },
        scales: $el.data('sparkline') ? {
          x: { display: false },
          y: { display: false }
        } : {}
      }
    });

    function loadData() {
      const source = $el.data('source');

      if (source === 'ajax' && $el.data('action')) {
        $.post(window.ajaxurl, { action: $el.data('action') }, res => {
          chart.data.labels = res.labels;
          chart.data.datasets = res.datasets;
          chart.update();
        });
      }

      if (source === 'external' && $el.data('external-url')) {
        $.ajax({
          url: $el.data('external-url'),
          method: $el.data('external-method'),
          headers: $el.data('external-headers') || {},
          success: res => {
            const data = getByPath(res, $el.data('external-path'));
            if (!data) return;
            chart.data.labels = data.labels;
            chart.data.datasets = data.datasets;
            chart.update();
          }
        });
      }
    }

    if ($el.data('live') == 1) {
      setInterval(loadData, $el.data('refresh') * 1000);
    }

    loadData();

    $el.closest('.chart').find('[data-export="png"]').on('click', () => {
      const a = document.createElement('a');
      a.href = chart.toBase64Image();
      a.download = 'chart.png';
      a.click();
    });

    $el.closest('.chart').find('[data-export="csv"]').on('click', () => {
      exportCSV(chart);
    });

  });

});

//Progress Bar
jQuery(function ($) {
  const $bars = $('[data-animate="1"]');

  if (!$bars.length || !('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;

      const el = entry.target;
      const $el = $(el);
      const value = parseInt($el.data('progress'), 10) || 0;

      /* -------------------
       * Linear progress bar
       * ------------------- */
      const $fill = $el.find('.progress-bar__fill');
      const $label = $el.find('.progress-bar__value');

      if ($fill.length) {
        $fill.css('width', value + '%');
      }

      if ($label.length) {
        $label.text(value + '%');
      }

      /* -------------------
       * Circular progress
       * ------------------- */
      const $circle = $el.find('.progress-circle .fill');
      if ($circle.length) {
        const length = 283; // must match SVG stroke-dasharray
        const offset = length - (value / 100) * length;

        $circle.css('stroke-dashoffset', offset);
      }

      /* -------------------
       * Count-up animation
       * ------------------- */
      const $num = $el.find('.value');
      if ($num.length) {
        let current = 0;
        const step = Math.ceil(value / 30);

        const interval = setInterval(function () {
          current += step;

          if (current >= value) {
            current = value;
            clearInterval(interval);
          }

          $num.text(current);
        }, 30);
      }

      observer.unobserve(el);
    });
  }, {
    threshold: 0.4
  });

  $bars.each(function () {
    observer.observe(this);
  });
});

//Rating
jQuery(function ($) {
  $('.rating').each(function () {
    const rating = $(this).data('rating');
    $(this).attr('aria-label', 'Rating ' + rating + ' out of 5');
  });
});

//Stats
jQuery(function ($) {

  /* ============================================================
   * Helpers
   * ============================================================ */

  function parseNumber(val) {
    if (typeof val === 'number') return val;
    return parseFloat(String(val).replace(/[^0-9.-]/g, '')) || 0;
  }

  function formatNumber(value, decimals = 0) {
    return value.toLocaleString(undefined, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  }

  /* ============================================================
   * Count-up animation
   * ============================================================ */

  function animateCount($item) {
    const $num = $item.find('.stat__number');
    if (!$num.length) return;

    const target = parseNumber($item.data('value'));
    const unit   = $item.data('unit') || '';
    const decimals = (String(target).split('.')[1] || '').length;

    let current = 0;
    const steps = 40;
    const step  = target / steps;

    $num.text('0' + unit);

    const interval = setInterval(() => {
      current += step;
      if (current >= target) {
        current = target;
        clearInterval(interval);
      }
      $num.text(formatNumber(current, decimals) + unit);
    }, 25);
  }

  /* ============================================================
   * Sparkline (canvas only – chart component handles others)
   * ============================================================ */

  function drawSparkline(canvas, points) {
    if (!canvas || !points || !points.length) return;

    const ctx = canvas.getContext('2d');
    const w = canvas.width;
    const h = canvas.height;

    const max = Math.max(...points);
    const min = Math.min(...points);
    const range = max - min || 1;

    ctx.clearRect(0, 0, w, h);
    ctx.beginPath();
    ctx.strokeStyle = getComputedStyle(canvas).color || '#6366f1';
    ctx.lineWidth = 2;

    points.forEach((v, i) => {
      const x = (i / (points.length - 1)) * w;
      const y = h - ((v - min) / range) * h;
      i === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
    });

    ctx.stroke();
  }

  /* ============================================================
   * Animate one stat item
   * ============================================================ */

  function animateStatItem(el) {
    const $item = $(el);

    animateCount($item);

    // Sparkline canvas (optional)
    const canvas = $item.find('canvas.stat__sparkline')[0];
    if (canvas && canvas.dataset.points) {
      try {
        drawSparkline(canvas, JSON.parse(canvas.dataset.points));
      } catch (e) {}
    }
  }

  /* ============================================================
   * Intersection Observer
   * ============================================================ */

  const io = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      const el = entry.target;
      animateStatItem(el);
      io.unobserve(el);
    });
  }, { threshold: 0.4 });

  function observeStats($block) {
    if ($block.data('animate') != 1) return;

    $block.find('.stats__item').each(function () {
      io.observe(this);
    });
  }

  /* ============================================================
   * Dashboard: Time range + REST refresh
   * ============================================================ */

  function initDashboard($block) {
    const endpoint = $block.data('endpoint');
    if (!endpoint) return;

    $block.on('click', '[data-range]', function () {
      const $btn = $(this);
      const range = $btn.data('range');

      $btn.addClass('is-active')
          .siblings().removeClass('is-active');

      $.get(endpoint, { range }, function (res) {
        if (!res || !res.items) return;

        res.items.forEach((item, i) => {
          const $stat = $block.find('.stats__item').eq(i);
          if (!$stat.length) return;

          $stat.data('value', item.value);
          $stat.find('.stat__number').text('0');
          animateCount($stat);
        });
      });
    });
  }

  /* ============================================================
   * Export (CSV / PNG)
   * ============================================================ */

  function initExport($block) {
    $block.on('click', '[data-export]', function () {
      const type = $(this).data('export');

      if (type === 'csv') {
        let csv = 'Label,Value\n';
        $block.find('.stats__item').each(function () {
          const label = $(this).find('.stat__label').text();
          const value = $(this).data('value');
          csv += `"${label}",${value}\n`;
        });

        const blob = new Blob([csv], { type: 'text/csv' });
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = 'statistics.csv';
        a.click();
      }

      if (type === 'png' && window.html2canvas) {
        html2canvas($block[0]).then(canvas => {
          const a = document.createElement('a');
          a.href = canvas.toDataURL('image/png');
          a.download = 'statistics.png';
          a.click();
        });
      }
    });
  }

  /* ============================================================
   * Init per block
   * ============================================================ */

  $('[data-stats="1"]').each(function () {
    const $block = $(this);

    observeStats($block);
    initDashboard($block);
    initExport($block);
  });

});
